export interface IData {
  _id: string;
  title: string;
  status: DataActiveStatusEnum;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
  featuredImage: string;
}
export enum DataActiveStatusEnum {
  Null = "Null",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}



export interface CategoryState {
  formData: IData;
  list: IData[];
  allList: IData[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  toggleLoading: boolean;
}

export type InitialState = CategoryState;
